import React from "react";
import "./Sections.scss";

function QA6() {
  return (
    <section className="interview">
      <div className="interview__interview">
        <p className="interview__interview__title">
          How do you turn that idea of the flower into a sketch? A sketch into a
          jewelry design?
        </p>
        <p className="interview__interview__copy">
          It starts when I see something out in the world that appeals to my
          eyes. Say, a beautiful flower or the rose pattern so common in
          Renaissance buildings here in Verona. So, I make a mental note, and
          use that note to convey, to create, something new. Just like
          Shakespeare, who transformed a real, 200-year old story into a unique
          play, I took a 600-year-old design and transformed it into a
          contemporary jewelry design.
        </p>
      </div>
    </section>
  );
}

export default QA6;
